import React from "react";
import Navbar from "../components/Navbar";
import Lumina from "../components/Lumina";
import Footer from "../components/Footer";

function LuminaProject() {
  return (
    <>
      <Navbar />
      <Lumina />
      <Footer />
    </>
  );
}

export default LuminaProject;
